import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
/**
 * @param publishedClient
 * @param query If `undefined`, no data is fetched
 * @returns If no result, `connection` is `undefined`.
 */
export function usePublishedEntitiesTotalCount(publishedClient, query) {
    const fetcher = useCallback(([_action, query]) => fetchEntitiesTotalCount(publishedClient, query), [publishedClient]);
    const { data: totalCount, error: totalCountError } = useSWR(query ? CACHE_KEYS.publishedEntitiesTotalCount(query) : null, fetcher);
    // useDebugLogChangedValues('usePublishedEntitiesTotalCount updated values', { publishedClient, query, totalCount, totalCountError, });
    return { totalCount, totalCountError };
}
async function fetchEntitiesTotalCount(publishedClient, query) {
    const result = await publishedClient.getEntitiesTotalCount(query);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=usePublishedEntitiesTotalCount.js.map